import React, { useEffect, useRef, useState } from "react";
import { Box, TextField, Button, Typography, Card, Dialog, DialogActions, DialogTitle, DialogContent, Slide } from "@mui/material";
import { getUserDetails, sendOtp, updateProfile, updateUsername } from "../../services/api";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const mobileRegex = /^[6-9]\d{9}$/;

const initialValues = {
    name: "",
    username: "",
    otp: ""
}
const UpdateProfile = ({ user, setUser }) => {
    const [formData, setFormData] = useState(initialValues);
    const [prevUsername, setPrevUsername] = useState("")
    const [usernameErr, setUsernameErr] = useState(false)
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const inputRefs = useRef([]);
    const [otpDialog, setOtpDialog] = useState(false)

    useEffect(() => {
        const fetchDetails = async () => {
            let resp = await getUserDetails()
            setFormData({
                name: resp?.data?.name,
                username: resp?.data?.username
            })
            setPrevUsername(resp?.data?.username)
        }

        fetchDetails()
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // setUser((prev) => ({
        //     ...prev,
        //     name: formData.name,
        //     email: formData.email,
        // }));
        let resp = await updateUsername({ username: formData?.username, otp: formData?.otp })
        if (resp.status === 200) {
            alert("Profile updated successfully!");
            setOtpDialog(false)
        }

    };

    const handleSubmitName = async () => {
        await updateProfile("1234", { name: formData?.name })
    }

    const handleGetOtp = async () => {
        if (!emailRegex.test(formData?.username) && !mobileRegex.test(formData?.username)) {
            setUsernameErr(true)
        }
        else {
            setUsernameErr(false)
            await sendOtp({
                digits: 6,
                appName: "Iaymaps console",
                username: emailRegex?.test(formData?.username) ?
                    formData?.username :
                    "+91" + formData?.username
            })
            setOtpDialog(true)
        }


    }

    // const handleKeyDown = (e, index) => {
    //     if (e.key === "Backspace") {
    //         if (!otp[index] && index > 0) {
    //             // Case 1: Field is empty, move back one field
    //             inputRefs.current[index - 1].focus();
    //         } else if (otp[index]) {
    //             // Case 2: Field has a digit, clear it and remain focused 
    //             // OR clear it and move back. Let's choose **clear and move back** for simplicity.

    //             // Clear the current digit first
    //             const newOtp = [...otp];
    //             newOtp[index] = "";
    //             setOtp(newOtp);

    //             // Move focus back immediately (if not the first box)
    //             if (index > 0) {
    //                 inputRefs.current[index - 1].focus();
    //             }
    //         }
    //     }
    //     // Add logic to focus on next box on arrow right
    //     if (e.key === "ArrowRight" && index < otp.length - 1) {
    //         inputRefs.current[index + 1].focus();
    //     }
    //     // Add logic to focus on previous box on arrow left
    //     if (e.key === "ArrowLeft" && index > 0) {
    //         inputRefs.current[index - 1].focus();
    //     }
    // };

    // const handleChangeOtp = (value, index) => {
    //     // Only allow single digit input
    //     if (value.length > 1) {
    //         // This is a safety check for fast typing/pasting, 
    //         // but maxLength: 1 on inputProps should prevent it.
    //         value = value.charAt(value.length - 1);
    //     }

    //     if (/^[0-9]?$/.test(value)) {
    //         const newOtp = [...otp];
    //         const prevValue = newOtp[index];
    //         newOtp[index] = value;

    //         setOtp(newOtp);

    //         // Focus logic: Only move forward if a NEW value was entered AND the input was previously empty.
    //         // If they clear a field, we want the Backspace handler to take over.
    //         if (value && !prevValue && index < otp.length - 1) {
    //             const nextInput = inputRefs.current[index + 1];
    //             // Ensure nextInput exists and hasn't been unmounted/lost ref
    //             if (nextInput) {
    //                 // Use a slight timeout to ensure the DOM is ready for focus 
    //                 // in case of component re-render/MUI internal state issues.
    //                 setTimeout(() => nextInput.focus(), 0);
    //             }
    //         }
    //     }
    // };

    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Slide direction="up" ref={ref} {...props} />;
    });

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: 'column',
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                gap: 10,
                backgroundColor: "#f5f5f5",
                p: 2,
            }}
        >
            <Card
                sx={{
                    p: 4,
                    width: "100%",
                    maxWidth: 400,
                    borderRadius: 3,
                    boxShadow: 3,
                    textAlign: "center",
                }}
            >
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Update Name
                </Typography>

                <div>
                    <TextField
                        fullWidth
                        label="Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        margin="normal"
                    />

                    <Button
                        onClick={handleSubmitName}
                        fullWidth
                        variant="contained"
                        color="primary"
                        type="submit"
                        sx={{ mt: 2, py: 1.2 }}
                    >
                        Save Changes
                    </Button>
                </div>
            </Card>

            <Card
                sx={{
                    p: 4,
                    width: "100%",
                    maxWidth: 400,
                    borderRadius: 3,
                    boxShadow: 3,
                    textAlign: "center",
                }}
            >
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Update Username
                </Typography>

                <div>
                    <TextField
                        fullWidth
                        label="Username"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        margin="normal"
                        error={Boolean(usernameErr)}            // 👈 highlights the field in red
                        helperText={usernameErr || ""}          // 👈 shows error message below field
                    />

                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        type="submit"
                        sx={{ mt: 2, py: 1.2 }}
                        disabled={prevUsername === formData?.username}
                        onClick={() => handleGetOtp()}
                    >
                        Get OTP
                    </Button>
                </div>
            </Card>

            <Dialog
                open={otpDialog}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setOtpDialog(false)}
                PaperProps={{
                    sx: {
                        borderRadius: 4,
                        p: 3,
                        textAlign: "center",
                        boxShadow: 6,
                        minWidth: 350,
                    },
                }}
            >
                <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.3rem" }}>
                    🔐 Verify OTP
                </DialogTitle>

                <DialogContent>
                    <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
                        Enter the 4-digit code sent to your registered email or mobile.
                    </Typography>

                    <Box sx={{ display: "flex", justifyContent: "center", gap: 1.5 }}>
                        <TextField name="otp" label="OTP"  value={formData.otp}
                        onChange={handleChange} />
                    </Box>
                </DialogContent>

                <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                    <Button
                        onClick={(e) => handleSubmit(e)}
                        variant="contained"
                        color="primary"
                        sx={{ px: 5, py: 1.2, borderRadius: 2 }}
                    >
                        Verify
                    </Button>
                    <Button onClick={() => setOtpDialog(false)} sx={{ color: "text.secondary" }}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default UpdateProfile;
